import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import {
    MenuItem,
    Grid,
    MuiButton,
    Box,
    CircularProgress,
} from '../../../components/mui';
import Form from '../../../components/Form';
import { messages as commonMessages } from '../../constants';
import { messages, validators, defaultCpuCoresNumber } from '../constants';

const { msgRequired, msgCreate, msgCancel } = commonMessages;
const {
    msgInvalidVmName,
    msgInvalidVmNameLength,
    msgInvalidCoresNumber,
    msgInvalidMemoryNumber,
} = messages;

const {
    isValidVmName,
    isValidVmNameLength,
    isValidCoresNumber,
    isValidMemoryNumber,
} = validators;

const CreateConfigForm = ({ images, onSubmit, onClose }) => {
    const handleValidate = (values) => {
        const { image } = values;

        const errors = {};

        if (!values.name) {
            errors.name = msgRequired;
        } else if (!isValidVmName(values.name)) {
            errors.name = msgInvalidVmName;
        } else if (!isValidVmNameLength(values.name)) {
            errors.name = msgInvalidVmNameLength;
        }

        if (!image) {
            errors.image = msgRequired;
        }

        if (!values.cpu) {
            errors.cpu = msgRequired;
        } else if (!isValidCoresNumber(values.cpu)) {
            errors.cpu = msgInvalidCoresNumber;
        }

        if (
            values.memory !== undefined &&
            values.memory !== '' &&
            !isValidMemoryNumber(values.memory)
        ) {
            errors.memory = msgInvalidMemoryNumber;
        }

        return errors;
    };

    const handleCancel = () => {
        onClose();
    };

    const fields = [
        {
            name: 'name',
            label: 'Name *',
            initialValue: '',
        },
        {
            select: true,
            name: 'image',
            label: 'Base Image *',
            SelectProps: {
                SelectDisplayProps: {
                    'data-testid': 'image-select',
                },
            },
            children:
                images &&
                images.map((image) => (
                    <MenuItem key={image.name} value={image}>
                        {image.name}
                    </MenuItem>
                )),
            initialValue: '',
        },
        {
            name: 'cpu',
            type: 'number',
            label: 'CPU *',
            initialValue: defaultCpuCoresNumber,
        },
        {
            name: 'memory',
            type: 'number',
            label: 'Memory (G)',
            initialValue: '',
        },
    ];

    const formContentRenderer = ({ isSubmitting }) => (
        <Box mt={2} mb={1}>
            <Grid container alignItems="center">
                <Grid item xs>
                    {isSubmitting && (
                        <Box data-testid="loading">
                            <CircularProgress size="1.5rem" />
                        </Box>
                    )}
                </Grid>
                <Grid item>
                    <MuiButton
                        data-testid="cancel"
                        onClick={handleCancel}
                        disabled={isSubmitting}
                    >
                        {msgCancel}
                    </MuiButton>
                    <MuiButton
                        data-testid="submit"
                        type="submit"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        {msgCreate}
                    </MuiButton>
                </Grid>
            </Grid>
        </Box>
    );

    return (
        <Form
            fields={fields}
            onValidate={handleValidate}
            onSubmit={onSubmit}
            formContentRenderer={formContentRenderer}
        />
    );
};

CreateConfigForm.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            type: PropTypes.string,
        }),
    ),
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

CreateConfigForm.defaultProps = {
    images: [],
    onSubmit: noop,
    onClose: noop,
};

export default CreateConfigForm;
